/** People as a CSV file to keep: the list as shown, quoted the boring correct way, with a BOM for Excel. */
import type { RegistrantSummary } from "../../../shared/types";

export function peopleCsv(rows: readonly RegistrantSummary[]): string {
  const q = (v: string) => `"${v.replaceAll('"', '""')}"`;
  const line = (cells: string[]) => cells.map(q).join(",");
  const head = line(["Name", "Email", "Rooms", "Stage", "Watched %", "Source", "Tags", "Last activity"]);
  const body = rows.map((r) =>
    line([
      r.name,
      r.email,
      r.webinars.join("; "),
      r.stage.label,
      String(r.watched_pct ?? 0),
      r.source ?? "",
      r.tags.join("; "),
      r.last_seen_at ? new Date(r.last_seen_at * 1000).toISOString() : "",
    ]),
  );
  const crlf = String.fromCharCode(13) + String.fromCharCode(10);
  // BOM first, so Excel reads the UTF-8 as UTF-8.
  return String.fromCharCode(65279) + [head, ...body].join(crlf) + crlf;
}

/** Hand the browser a CSV to save, named for what it holds and today. */
export function downloadCsv(csv: string, name: string): void {
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${name}-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
